import { render, staticRenderFns } from "./geren.vue?vue&type=template&id=0b6d9b14"
import script from "./geren.vue?vue&type=script&lang=js"
export * from "./geren.vue?vue&type=script&lang=js"
import style0 from "./geren.vue?vue&type=style&index=0&id=0b6d9b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports